import type { ColumnDef } from '@tanstack/react-table';
import { useTranslation } from 'react-i18next';
import type { ShopShopReadModel } from '@r/api/generated/client.schemas.ts';

type Shop = ShopShopReadModel;

export const useShopColumns = (): ColumnDef<Shop>[] => {
  const { t } = useTranslation();

  return [
    {
      accessorKey: 'id',
      header: t('label.shop.id')
    },
    {
      accessorKey: 'displayName',
      header: t('label.shop.name')
    },
    {
      accessorKey: 'opening_date',
      header: t('label.shop.opening.date'),
      cell: ({ row }) => {
        if (row.original.shopWorkspace?.shopOpeningDate) {
          return row.original.shopWorkspace.shopOpeningDate.slice(0, 10);
        }
        return null;
      }
    },
    {
      accessorKey: 'closing_date',
      header: t('label.shop.closing.date'),
      cell: ({ row }) => {
        if (row.original.shopWorkspace?.shopClosingDate) {
          return row.original.shopWorkspace.shopClosingDate.slice(0, 10);
        }
        return null;
      }
    },
    {
      accessorKey: 'min_point',
      header: t('label.shop.min.point'),
      cell: ({ row }) => {
        if (row.original.shopWorkspace?.minPoint != null) {
          return row.original.shopWorkspace.minPoint;
        }
        return null;
      }
    },
    {
      accessorKey: 'status',
      header: t('label.shop.is.active'),
      cell: ({ row }) => {
        if (row.original.shopWorkspace?.isActive) {
          return t('label.shop.active');
        }
        return t('label.shop.disabled');
      }
    }
  ];
};
